import { formatDate } from "@/utils";
import { Chip } from "@mui/material";
import * as Styled from "./TaskChips.styles";
import { RenderIf } from "@adl/smart-ui-library";
import { ITask } from "@/redux/store.types";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "@/hooks";
import { setSelectedCase } from "@/redux/casesSlice";

type Props = {
  task: ITask;
  data: any;
};

const TaskChips = ({ task, data }: Props) => {
  const {
    createdAt,
    createdBy,
    verified,
    verifiedAt,
    verifiedBy,
    document,
    lastDownloadedUser,
    lastUploadedUser,
    rejectedBy,
  } = task;
  const navigate = useNavigate();
  const appDispatch = useAppDispatch();
  return (
    <Styled.TaskChips>
      <Chip variant="outlined" label={`Created: ${formatDate(createdAt)}`} />
      <Chip variant="outlined" label={`Created by: ${createdBy}`} />

      <Chip variant="outlined" label={`Category: ${document.categoryName}`} />
      <Chip variant="outlined" label={`Project: ${task.case?.ShortName}`} />
      <Chip
        variant="outlined"
        label={`Project Code: ${task.case?.P_number}`}
        onClick={() => {
          appDispatch(setSelectedCase(data));

          navigate(`/case/${task?.deliveryEngagementId}`);
        }}
      />
      <RenderIf isTrue={Boolean(lastDownloadedUser)}>
        <Chip
          variant="outlined"
          label={`Last Downloaded by: ${lastDownloadedUser}`}
        />
      </RenderIf>

      <RenderIf isTrue={Boolean(lastUploadedUser)}>
        <Chip
          variant="outlined"
          label={`Last Uploaded by: ${lastUploadedUser}`}
        />
      </RenderIf>

      <RenderIf isTrue={Boolean(rejectedBy)}>
        <Chip variant="outlined" label={`Rejected by: ${rejectedBy}`} />
      </RenderIf>

      <RenderIf isTrue={verified}>
        <RenderIf isTrue={Boolean(verifiedAt)}>
          <Chip
            variant="outlined"
            label={`Validated: ${formatDate(verifiedAt)}`}
          />
        </RenderIf>

        <Chip variant="outlined" label={`Validated by: ${verifiedBy}`} />
      </RenderIf>
    </Styled.TaskChips>
  );
};

export default TaskChips;
